import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { IAgentApplication } from "../../models/agentApplication.models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AgentApplicationService {
  constructor(private http: HttpClient) {}

  loadAgentApplications = (): Observable<IAgentApplication[]> => {
    return this.http.get(
      `${environment.apiUrl}/getAgentApplications`
    ) as Observable<IAgentApplication[]>;
  };
}
